import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Registra os font-sizes custom do design system para que o tailwind-merge
// nao os confunda com cores `text-*`. Sem isto, `text-body-lg` (size) e
// `text-canvas` (cor) caem no mesmo grupo de conflito `text-*` e a cor e
// descartada — deixando o texto do CTA primario (verde) ilegivel (~1.2:1).
// Manter sincronizado com `tailwind.config.js -> theme.extend.fontSize`.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-lg',
            'display-md',
            'display-sm',
            'body-lg',
            'body-md',
            'label-lg',
            'label-md',
            'label-sm',
            'hero',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
